import * as React from "react";
const SvgLogoFacebook = (props) => /* @__PURE__ */ React.createElement("svg", { "data-name": "Group 13552", xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { "data-name": "Rectangle 4346", style: {
  fill: "transparent"
}, d: "M0 0h27.862v24H0z" }), /* @__PURE__ */ React.createElement("path", { "data-name": "facebook (2)", d: "M17.576 3.985h2.544V.169C19.68.117 18.171 0 16.414 0c-3.667 0-6.18 1.987-6.18 5.639V9H6.187v4.266h4.047V24H15.2V13.267h3.883L19.7 9h-4.5V6.062c0-1.233.387-2.077 2.381-2.077z", transform: "translate(.778)", style: {
  fill: "#3f99f7",
  opacity: 0.996
} }));
export default SvgLogoFacebook;
